"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageTypes = void 0;
exports.pageTypes = [
    'home',
    'search',
    'favorites',
    'trending',
    'landing-page',
    'your-tech',
    'sub-category',
    'how-it-works',
    'category',
    'deals',
    'pdp',
    'others',
    'your-profile',
    'your-payments',
];
//# sourceMappingURL=constants.js.map